import React from "react";

const CustomerCampaignsList = React.lazy(() => import('src/pages/customer_campaigns/CustomerCampaignsList'));
const CustomerCampaignDetail = React.lazy(() => import('src/pages/customer_campaigns/CustomerCampaignDetail'));

const routes = [
    { path: '/dashboard/customer-campaigns-list/detail/:id', name: 'Campaign Detail', element: CustomerCampaignDetail },
    { path: '/dashboard/customer-campaigns-list', name: 'Customer Campaigns', element: CustomerCampaignsList },
];

export default routes;
